
import React, {Component} from 'react';
import {Button,ButtonToolbar} from 'react-bootstrap'
import Select from 'react-select'
import moment from 'moment'
import FontAwesome from 'react-fontawesome'
import HrStore from '../../stores/HrStore'
import PeriodSelectDateModal from './PeriodSelectDateModal'

class CkSlipPeriod extends Component {

  constructor(...args){
    super(...args)
    this.hrConfig = {}
    this.slipPeriod = []
    
    var dt = new Date();
    let month = dt.getMonth() + 1
    month = ('0000'+month).slice(-2)
    let year = (dt.getFullYear()*1+543)
    
    let options = this.getWeekDayOnMonth(year,month)
    let option  = this.getCurrentRange(options,dt);

    this.state = {showPeriod:false,options:options,year:year,month:month,rangeValue:option}
    
  }

  componentDidMount(){
    // let {year,month,rangeValue} = this.state
    // if(this.props.onInitPeriod!==undefined){
    //   this.props.onInitPeriod({year:year,month:month,rangeValue:rangeValue})
    // }
  }

  componentWillReceiveProps(newProps){
    if(newProps.hrConfig!==null && Object.entries(newProps.hrConfig).length!==0 && newProps.hrConfig!==this.hrConfig){
      
      this.hrConfig = newProps.hrConfig
      this.slipPeriod = newProps.slipPeriod

      let {year,month} = this.state
      let options = this.getWeekDayOnMonth(year,month)
      let rangeValue  = this.getCurrentRange(options,new Date());
      this.setState({options:options,rangeValue:rangeValue})
      if(this.props.onChange!==undefined){
        this.props.onChange({year:year,month:month,rangeValue:rangeValue,options:options})
      }
    }
    
    if (newProps.show&&newProps.show!=this.props.show) {
      let {year,month,rangeValue} = this.state
      if(this.props.onInitPeriod!==undefined){
        this.props.onInitPeriod({year:year,month:month,rangeValue:rangeValue})
      }
    }
  }

  onYearChange(e){
    let year = e.value,{month,rangeValue} = this.state, that = this
    
    const options = this.getWeekDayOnMonth(year,month)
    rangeValue = options[0]
    that.setState({year:year,loading:true,options:options,rangeValue:rangeValue})

    //this.loadAllSlipWage(emType,year,month,rangeValue)
    if(this.props.onChange!==undefined){
      this.props.onChange({year:year,month:month,rangeValue:rangeValue,options:options})
    }
  }

  onMonthChange(e){
    let month = e.value,{year,rangeValue} = this.state, that = this
    
    const options = this.getWeekDayOnMonth(year,month)
    rangeValue = options[0]
    this.setState({month:month,loading:true,options:options,rangeValue:rangeValue})
    //this.loadAllSlipWage(emType,year,month,rangeValue)
    if(this.props.onChange!==undefined){
      this.props.onChange({year:year,month:month,rangeValue:rangeValue,options:options})
    }
  }

  onSelectPeriod(period){
    let {year,month,options,rangeValue} = this.state
    let {hrConfig,slipPeriod} = this
    
    console.log('rangeVal',rangeValue,period)

    let monthText = this.getMonthText(month)

    let dayArr = period.start_date.split("/");
    let startDay = dayArr[0]*1
    dayArr = period.end_date.split("/");
    let endDay = dayArr[0]*1

    if(hrConfig && hrConfig.period && "fullmonth"===hrConfig.period){
      options[0] = this.getRangeOption(year,month,startDay,endDay,monthText,'secondhalf')
      rangeValue = options[0]      
    }else{
      if(rangeValue.seqInMonth==='firsthalf'){
        options[0] = this.getRangeOption(year,month,startDay,endDay,monthText,'firsthalf')
        rangeValue = options[0]
      }else if(rangeValue.seqInMonth==='secondhalf'){
        options[1] = this.getRangeOption(year,month,startDay,endDay,monthText,'secondhalf')
        rangeValue = options[1]
      }    
    }

    let periodic = HrStore.getPeriodic(year,month,rangeValue.value)
    HrStore.saveSlipPeriod(periodic,year,month,rangeValue,()=>{
      this.setState({showPeriod:false,options:options,rangeValue:rangeValue},()=>{
        if(this.props.onChange){
          this.props.onChange({year:year,month:month,rangeValue:rangeValue,options:options})
        }        
      })
    },()=>{

    })
    
  }

  onRangeChange(e){
    let {year,month,options} = this.state, that = this
    
    let rangeValue = e

    this.setState({rangeValue:rangeValue,loading:true})
    //this.loadAllSlipWage(emType,year,month,rangeValue)
    if(this.props.onChange!==undefined){
      this.props.onChange({year:year,month:month,rangeValue:rangeValue,options:options})
    }
  }

  onPeriodEditClick(){
    this.setState({showPeriod:true})
  }

  getYearOptions(){
    let options = []
    var dt = new Date();
    for(let i=(dt.getFullYear()*1+543);i>=2558;i--){
      options.push({label:i,value:i})
    }
    return options;
  }

  getMonthOptions(){
    return [{label:'มกราคม',value:'01'},{label:'กุมภาพันธ์',value:'02'},
            {label:'มีนาคม',value:'03'},{label:'เมษายน',value:'04'},
            {label:'พฤษภาคม',value:'05'},{label:'มิถุนายน',value:'06'},
            {label:'กรกฎาคม',value:'07'},{label:'สิงหาคม',value:'08'},
            {label:'กันยายน',value:'09'},{label:'ตุลาคม',value:'10'},
            {label:'พฤศจิกายน',value:'11'},{label:'ธันวาคม',value:'12'},
          ]
  }

  getCountOfWorkOptions2(){
    let options = []
    for(let i=10;i<31;i++){
      options.push({label:i+' วัน',value:i})
    }
    return options;
  }

  getMonthText(month){
    let result=''
    this.getMonthOptions().map((item,index)=>{

      if(item.value*1===month*1){
        result = item.label
      }
      return item
    })
    return result
  }

  getWeekDay(year,month,day){
    let myDate = new Date();
    myDate.setFullYear(year-543);
    myDate.setMonth((month*1)-1);
    myDate.setDate(day);
    return myDate.getDay()
  }

  getRangeOption(year,month,start,end,monthText,seqInMonth){
    let between = start+'-'+end
    let startDate = (year-543)+'/'+((start>20)?(month*1-1):month)+'/'+start
    let endDate   = (year-543)+'/'+month+'/'+end
    
    let countOfDays = moment(endDate, "YYYY/MM/DD").diff(moment(startDate, "YYYY/MM/DD"), 'days')+1  
    return {label:start+' - '+end+' '+monthText,value:between,startDate:startDate,endDate:endDate,countOfWork:countOfDays,seqInMonth:seqInMonth}
  }

  getPeriodToOption(period){
    let year = period.year*1+543
    let month = period.month*1
    let monthText = this.getMonthText(month)
    let dStart = moment(period.start_date,'YYYY-MM-DD').format('DD')
    let dEnd   = moment(period.end_date,'YYYY-MM-DD').format('DD')

    let option = this.getRangeOption(year,month,dStart,dEnd,monthText,period.seq_in_month)
    // console.log('getPeriodToOption',period,year,month,dStart,dEnd,option)
    return option
  }

  getSlipPeriodConfig(slipPeriod,year,month){
    if(slipPeriod!==undefined){
      return slipPeriod.reduce((rresult,item)=>{
        if(item.month*1===month*1){
          rresult.push(item)
        }
        return rresult
      },[])    
    }else{
      return []
    }
  }

  getWeekDayOnMonth(year,month){
    let {hrConfig,slipPeriod} = this
    let monthText = this.getMonthText(month)
    let options = []

    if(hrConfig && hrConfig.period!==undefined && "fullmonth"===hrConfig.period){
      const d = new Date(year - 543, month , 0);
      options = [this.getRangeOption(year,month,1,d.getDate(),monthText,'secondhalf')]
      if(slipPeriod.length===1){        
        if(slipPeriod[0].seq_in_month=='secondhalf'){
          options[0] = this.getPeriodToOption(slipPeriod[0]);
        }               
      }
    }else if(hrConfig && hrConfig.period!==undefined && "halfmonth"===hrConfig.period){
      
      const d = new Date(year - 543, month , 0);
      const halfNumber =  ((hrConfig.half_number!==undefined)?hrConfig.half_number:15)*1
      options = [this.getRangeOption(year,month,1,halfNumber,monthText,'firsthalf'),this.getRangeOption(year,month,(halfNumber+1),d.getDate(),monthText,'secondhalf')]
    }else{
      let endDay = 28      
      let preMonth = (month*1===1)?12:month
      let year1 = (month*1===1)?year-1:year
      let wkDay1 = this.getWeekDay(year1,month*1-1,endDay);
      let wkDay2 = this.getWeekDay(year,month,13);
      let wkDay3 = this.getWeekDay(year,month,endDay);

      //Check day is Sunday
      // console.log('hrConfig',hrConfig,this.slipPeriod,wkDay1,wkDay2,wkDay3)
      let slipPeriod = this.getSlipPeriodConfig(this.slipPeriod,year,month)
      if(slipPeriod.length===2){
        options = [this.getPeriodToOption(slipPeriod[0]),this.getPeriodToOption(slipPeriod[1])]       
      }else if(wkDay1===0 && wkDay2===0 && wkDay3===0){
        options = [this.getRangeOption(year,month,30,14,monthText,'firsthalf'),this.getRangeOption(year,month,15,29,monthText,'secondhalf')]
      }else if(wkDay1===0 && wkDay2===0 ){
        options = [this.getRangeOption(year,month,30,14,monthText,'firsthalf'),this.getRangeOption(year,month,15,28,monthText,'secondhalf')]      
      }else if(wkDay1===0 && wkDay3===0 ){
        options = [this.getRangeOption(year,month,30,13,monthText,'firsthalf'),this.getRangeOption(year,month,14,29,monthText,'secondhalf')]      
      }else if(wkDay2===0 && wkDay3===0 ){
        options = [this.getRangeOption(year,month,29,14,monthText,'firsthalf'),this.getRangeOption(year,month,15,29,monthText,'secondhalf')]      
      }else if(wkDay3==0){
        options = [this.getRangeOption(year,month,29,13,monthText,'firsthalf'),this.getRangeOption(year,month,14,29,monthText,'secondhalf')]             
      }else{
        options = [this.getRangeOption(year,month,29,13,monthText,'firsthalf'),this.getRangeOption(year,month,14,28,monthText,'secondhalf')]      
      }
      
      if(slipPeriod.length===1){        
        if(slipPeriod[0].seq_in_month=='firsthalf'){
          options[0] = this.getPeriodToOption(slipPeriod[0]);
        }else if(slipPeriod[0].seq_in_month=='secondhalf'){ 
          options[1] = this.getPeriodToOption(slipPeriod[0]);
        }                
      }
      // console.log('getDay',wkDay1,wkDay2,wkDay3,year,month,options)
    }
    //if(myDate.getDay() == 6 || myDate.getDay() == 0) alert('Weekend!');
    return options;
  }

  getCurrentRange(options,date){
    let compareDate = moment(date)
    //let compareDate = moment('2017/05/29','YYYY/MM/DD')
    let option = null
    options.map((item,index)=>{
      let startDate = moment(item.startDate, "YYYY/MM/DD")
      let endDate = moment(item.endDate, "YYYY/MM/DD")  
      //console.log('compare',compareDate,startDate,endDate)    
      //console.log('item',item,compareDate.toString(),startDate.toString(),endDate.toString())
      if(compareDate.isSameOrAfter(startDate) && compareDate.isSameOrBefore(endDate)){
        //console.log('Yes')
        option = item
      }
      return item
    })   

    if(option===null){
      option = options[0]
    } 

    return option
  }

  getRangeText(){
    let {rangeValue,year} = this.state
    let betweenTitle = rangeValue.label + ' ' + year
    return betweenTitle
  }

  getCountOfWorkOptions(){
    let {year,month} = this.state
    return this.getWeekDayOnMonth(year,month)
  }

  render(){
    let {year,month,rangeValue,options,showPeriod} = this.state
    return (
        <div className=" navbar-left">
          <div style={{width:'80px',display:'inline-block'}}>
            <Select value={year} options={this.getYearOptions()} onChange={this.onYearChange.bind(this)}  clearable={false}/>
          </div>{' '}
          <div style={{width:'120px',display:'inline-block'}}>
            <Select
              clearable={false}
              value={month}
              options={this.getMonthOptions()}
              onChange={this.onMonthChange.bind(this)}
            />
          </div>{' '}
          <div style={{width:'180px',display:'inline-block'}}>
            <Select
              placeholder='เลือกช่วงสัปดาห์'
              clearable={false}
              value={(rangeValue!==null)?rangeValue.value:''}
              options={options}
              onChange={this.onRangeChange.bind(this)}
            />            
          </div>{' '}
          <div style={{width:'40px',display:'inline-block'}}>
            <ButtonToolbar>
              <Button bsStyle='link' onClick={this.onPeriodEditClick.bind(this)}><FontAwesome name='pencil'/></Button>
            </ButtonToolbar>
          </div>{' '}
          <PeriodSelectDateModal 
            show={showPeriod} 
            rangeValue={rangeValue}
            title={'เลือกช่วงเวลาการ'}
            onSelect={this.onSelectPeriod.bind(this)}
            onClose={()=>{this.setState({showPeriod:false})}}
          />
        </div>
    )
  }
}

CkSlipPeriod.defaultProps = {
  show:false,
  hrConfig : {},
  slipPeriod:[]
}

export default CkSlipPeriod;





// WEBPACK FOOTER //
// ./src/component/element/CkSlipPeriod.js